import { useContext } from 'react'
import { I18nContext } from './i18nContext'
import type { I18nContextValue } from './i18nContext'

export function useT(): I18nContextValue {
  const ctx = useContext(I18nContext)
  if (!ctx) throw new Error('useT должен использоваться внутри I18nProvider')
  return ctx
}
